import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisV } from '@fortawesome/pro-solid-svg-icons';

import ManagedInput from 'components/form/managed_input';
import { formatPercent, USD } from 'helpers/formatters/number_formats';

import './styles.scss';

export default function CompRow({ children, comp, connectDragSource, selected, onDeselect, onSelect }) {
  const details = [];
  if (comp.type === 'Research::Sale') {
    details.push(<div key="price">{USD.format(comp.price, { round: true })}</div>);
    details.push(<div key="size">{comp.buildingSizeLabel}</div>);

    if (comp.saleDate) {
      details.push(<div key="date">Sold {comp.saleDate}</div>);
    }

    if (comp.capRatePct != null) {
      details.push(<div key="capRate">Cap: {formatPercent(comp.capRatePct / 100)}</div>);
    }
  } else {
    details.push(<div key="price">{comp.leaseRateLabel}</div>);
    details.push(<div key="size">{comp.sizeLabel}</div>);

    if (comp.leaseDate) {
      details.push(<div key="date">Leased {comp.leaseDate}</div>);
    }
  }

  const selectable = onDeselect && onSelect;
  function handleClick() {
    if (selectable) {
      selected ? onDeselect(comp) : onSelect(comp);
    }
  }

  return (
    <div className={classNames('comp-row p-3', { clickable: selectable })} onClick={handleClick}>
      <div className="row">
        <div className="col col-4 col-sm-6 d-flex align-items-center">
          {connectDragSource && connectDragSource(
            <span className="drag-handle px-2 text-muted clickable">
              <FontAwesomeIcon icon={faEllipsisV}/>
            </span>
          )}
          {selectable && <ManagedInput checked={selected} className="me-3" type="checkbox" />}
          <img className="d-none d-lg-block me-3" src={comp.photoUrl} />
          <div className="section text-muted">
            <div>{comp.displayName}</div>
            <div>{comp.displayName === comp.address ? comp.addressTwoLine[1] : comp.addressOneLine}</div>
            <div>{comp.propertyType}</div>
          </div>
        </div>

        <div className="col col-8 col-sm-6 d-flex align-items-center">
          <div className="section flex-fill d-none d-md-block text-muted">
            {details}
          </div>

          <div className="flex-grow text-end">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
}

CompRow.propTypes = {
  children: PropTypes.node,
  comp: PropTypes.shape({
    address: PropTypes.string,
    addressOneLine: PropTypes.string,
    addressTwoLine: PropTypes.arrayOf(PropTypes.string).isRequired,
    buildingSizeLabel: PropTypes.string,
    capRatePct: PropTypes.number,
    displayName: PropTypes.string,
    leaseDate: PropTypes.string,
    leaseRateLabel: PropTypes.string,
    photoUrl: PropTypes.string,
    price: PropTypes.number,
    propertyType: PropTypes.string,
    saleDate: PropTypes.string,
    sizeLabel: PropTypes.string,
  }).isRequired,
  connectDragSource: PropTypes.func,
  selected: PropTypes.bool,
  onDeselect: PropTypes.func,
  onSelect: PropTypes.func,
};
